import { Helmet } from "react-helmet-async";
import { Navigate } from "react-router-dom";

/** Client-side redirect. Real HTTP 301s need a Cloudflare rule; this SPA cannot set status codes. */
export default function RedirectTo({ to }: { to: string }) {
  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, follow" />
        <link rel="canonical" href={`https://peptidex.ai${to.split("?")[0]}`} />
        <title>Redirecting | PeptideX</title>
      </Helmet>
      <Navigate to={to} replace />
    </>
  );
}
